export function validatePhone(phone) {
  const regex = /^[0-9]{5,10}$/;
  return regex.test(phone);
}

export function validateFiscalCode(fiscalCode) {
  const regex = /^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;
  return regex.test(fiscalCode);
}

export function validateVatNumber(vatNumber) {
  const regex = /^[0-9]{11}$/;
  return regex.test(vatNumber);
}

export function validateEmail(email) {
  const regex = /^[\w\-\.]*[\w\.]\@[\w\.]*[\w\-\.]+[\w\-]+[\w]\.{1}[\w]+[\w $]/;
  return regex.test(email);
}

export function validatePostalCode(postalCode) {
  const regex = /^\d{5}$/;
  return regex.test(postalCode);
}
